import { useNavigate } from "react-router";
import { TableToolbar } from "@rio-cloud/rio-uikit";
import { fixedColumns, scrollableColumns } from "./tableConfigs";
import { renderTableCaption, renderTableHead } from "../../../../utils/tableUtils";

import "../styles.scss";

const SkeletonTable = (props: { onlyRows?: boolean | undefined }) => {
  const navigate = useNavigate();

  return (
    <div id="TableCommonDemo">
      {!props.onlyRows && (
        <TableToolbar>
          <div className="table-toolbar-container">
            <div className="table-toolbar-group-right">
              <div className="table-toolbar-column table-toolbar-column-spacer">
                <button
                  type="button"
                  className="btn !bg-[#31b5c0] hover:!bg-[#2a9ca8] !text-white padding-7"
                  onClick={() => navigate(`/control-tower/appointments/appointment`)}
                >
                  <span className="text-capitalize padding-right-5">
                    Criar agendamento
                  </span>
                  <span
                    className="rioglyph rioglyph-plus-sign"
                    aria-hidden="true"
                  />
                </button>
              </div>
            </div>
          </div>
        </TableToolbar>
      )}

      <div className="tables-row">
        <div className="tables-row__fixed">
          <table
            className="table table-layout-fixed table-bordered"
          >
            <colgroup>{fixedColumns.map((column) => renderTableCaption(column.value, column.details))}</colgroup>
            {!props.onlyRows && (
              <thead>
                <tr>{fixedColumns.map((column) => renderTableHead(column.value, column.label, "vehicle", () => {}))}</tr>
              </thead>
            )}
            <tbody>
              {new Array(50).fill(0).map((row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  {fixedColumns.map((column, colIndex) => (
                    <td
                      key={`${column}-${rowIndex}-${colIndex}`}
                      data-field={column.label}
                      style={column.value !== "veiculo" ? {whiteSpace: 'nowrap'} : {}}
                      className="animate-pulse"
                    >
                      <div className="w-3/4 h-4 bg-gray-300 rounded" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="scrollabe-table">
          <table className="table table-layout-fixed table-column-overflow-hidden table-bordered table-head-filled"  style={{ minWidth: '1650px' }}>
            <colgroup>
              {scrollableColumns.map((column) => renderTableCaption(column.value, column.details))}
            </colgroup>
            {!props.onlyRows && (
              <thead>
                <tr>{scrollableColumns.map((column) => renderTableHead(column.value, column.label, "vehicle", () => {}))}</tr>
              </thead>
            )}
            <tbody>
              {new Array(50).fill(0).map((row: any, rowIndex: number) => (
                <tr key={rowIndex}>
                  {scrollableColumns.map((colum) => (
                    <td key={colum.value} className="animate-pulse">
                      <div className="w-3/4 h-4 bg-gray-300 rounded" />
                    </td>
                  ))}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default SkeletonTable;
